
import React from 'react';
import { Link } from 'react-router-dom';

const MetalTypesGrid = () => {
  const metalTypes = [
    {
      name: "Ferraille",
      description: "Rachat de ferraille industrielle et de récupération",
      link: "/nos-services/achat-metaux/ferraille"
    },
    {
      name: "Cuivre",
      description: "Achat de cuivre nu, cuivre millberry, et déchets de cuivre",
      link: "/nos-services/achat-metaux/cuivre"
    },
    {
      name: "Aluminium",
      description: "Recyclage d'aluminium : profilés, tôles, déchets d'alu",
      link: "/nos-services/achat-metaux/aluminium"
    },
    {
      name: "Plomb",
      description: "Achat de plomb de couverture, batteries au plomb, etc.",
      link: "/nos-services/achat-metaux/plomb"
    },
    {
      name: "Zinc",
      description: "Recyclage de zinc de toiture, gouttières en zinc, etc.",
      link: "/nos-services/achat-metaux/zinc"
    },
    {
      name: "Laiton",
      description: "Achat de déchets de laiton, robinetterie, etc.",
      link: "/nos-services/achat-metaux/laiton"
    },
    {
      name: "Inox",
      description: "Recyclage d'inox : chutes, équipements, cuves inox",
      link: "/nos-services/achat-metaux/inox"
    },
    {
      name: "Batteries",
      description: "Collecte et recyclage de batteries usagées",
      link: "/nos-services/achat-metaux/batteries"
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-fabre-gray mb-4">
            Tous vos métaux rachetés aux meilleurs prix
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto">
            Du cuivre millberry à la ferraille industrielle, nous rachetons tous types de métaux 
            avec une expertise reconnue depuis plus de 25 ans.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {metalTypes.map((metal, index) => (
            <Link key={index} to={metal.link} className="group">
              <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow border border-gray-100 group-hover:border-red-200">
                <h3 className="font-bold text-gray-800 mb-2">{metal.name}</h3>
                <p className="text-gray-600 text-sm mb-3">
                  {metal.description}
                </p>
                <div className="text-red-600 font-medium group-hover:text-red-700">En savoir plus →</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MetalTypesGrid;
